export default {"src":"/_next/static/media/client-askona-auth-background-mobile.d290c9e9.svg","height":732,"width":375};